import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfSynthesisJobRetryDialog } from '@Pages/RetroSynthesis/SynthesisJobRetry/constants';

export const openSynthesisJobRetryDialog = (project, status, type, onRetry) => {
  return updateDialog({
    id: typeOfSynthesisJobRetryDialog,
    dialogType: typeOfSynthesisJobRetryDialog,
    project,
    status,
    type,
    onRetry,
  });
};
